/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { isArray, } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { t } from 'i18next';
import { searchTransportCompany } from '../../../../actions/formAction';

function TransportCompanyMenu() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedTransportCompany, setSelectedTransportCompany] = useState([]);
    const [anchor, setAnchor] = useState(null);
    const open = Boolean(anchor);
    const [debouncedInputValue, setDebouncedInputValue] = useState('');
    const [input, setInput] = useState('');



    const formReducer = useSelector((state) => state.form);
    const [mainData, setMainData] = useState([]);

    useEffect(() => {


        if (formReducer.isLoadingTransportCompanyData === 'succeeded') {

            const newData = formReducer.transportCompany?.["{}"] || [];
            const addedList = newData.filter(item2 => !mainData.some(item1 => item1.id === item2.id));

            if (addedList) {
                setMainData(prevData => [...prevData, ...addedList]);
            }
        }

        const searchParams = new URLSearchParams(location.search);
        const TransportCompanyParam = searchParams.get('TransportCompany');

        if (TransportCompanyParam === null) {
            setSelectedTransportCompany([]);
        } else {
            const selectedTypes = TransportCompanyParam.split(',').map(Number);
            setSelectedTransportCompany(selectedTypes);
        }
    }, [formReducer.isLoadingTransportCompanyData, location.search]);

    useEffect(() => {
        updateURLQuery();
    }, [selectedTransportCompany]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            dispatch(searchTransportCompany({ name: input }));
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [debouncedInputValue, dispatch]);

    const updateURLQuery = () => {
        if (anchor) {
            const searchParams = new URLSearchParams(location.search);
            if (selectedTransportCompany.length === 0) {
                searchParams.delete('TransportCompany');
            } else {
                searchParams.set('TransportCompany', selectedTransportCompany.join(','));
            }
            navigate({ search: searchParams.toString() });
        }
    };

    const handleAutocompleteChange = (event, value) => {
        setSelectedTransportCompany(value.map((item) => item.id));
    };

    const handleClick = (event) => {
        setAnchor(event.currentTarget);
    };

    const handleClose = () => {
        setAnchor(null);
    };



    return (
        <Box className="TransportCompany">
            <Button
                id="TransportCompany"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                TransportCompany
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchor}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'TransportCompany',
                }}
                PaperProps={{
                    style: {
                        width: '25%',
                        maxWidth: '100%',
                        maxHeight: '300px',
                        left: 0,
                        right: 0,
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'wrap',
                        width: '100%',
                        maxHeight: '300px',
                        overflow: 'auto',
                        overflowY: 'hidden',
                        p: 2
                    }}
                >
                    <Autocomplete
                        multiple
                        id="TransportCompany-autocomplete"
                        options={mainData}
                        value={selectedTransportCompany.map(id => isArray(mainData) ? mainData.find(item => item.id === id) || null : [])}
                        onChange={handleAutocompleteChange}
                        inputValue={input}
                        onInputChange={(event, value) => {

                            setDebouncedInputValue(value);
                        }}
                        clearText="Clear"

                        disableCloseOnSelect
                        getOptionLabel={(option) => option?.name}
                        loading={formReducer.isLoadingTransportCompanyData === 'pending'}

                        renderInput={(params) => <TextField {...params} label={`#${t('TransportCompany')}`} onChange={({ target }) => setInput(target.value)} InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {formReducer.isLoadingTransportCompanyData === 'pending' ? <CircularProgress color="error" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }} />}








                    />

                </Box>
            </Menu>
        </Box>
    );
}

export default TransportCompanyMenu;
